import cx from 'classnames';
import { ChangeEvent, InputHTMLAttributes, KeyboardEventHandler } from 'react';
import css from './Toggle.module.scss';

interface IToggleProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'size'> {
  onChange?: (event?: ChangeEvent<HTMLInputElement>) => void;
  size?: 'sm' | 'lg';
}

export const Toggle = ({
  className,
  onChange,
  size = 'lg',
  ...rest
}: IToggleProps) => {
  const handleKeyDown: KeyboardEventHandler<HTMLDivElement> = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      onChange?.();
    }
  };

  return (
    <div
      className={cx(css.toggle, css[size], className)}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <input type="checkbox" onChange={onChange} tabIndex={-1} {...rest} />
      <span className={cx(css.slider, css[size])} />
    </div>
  );
};
